<template>
  <DropDownMenuBase
    :optionList="optionList"
    :direction="direction"
    :isSimpleList="isSimpleList"
    :width="width"
    :keepOrder="keepOrder">
    <template #header>
      <slot name="header" />
    </template>
    <template #item="{ item }">
      <DropDownMenuItem
        :id="item?.id"
        :selected="item?.id === value"
        :dataTest="item?.dataTest || `dropdown-option-${item?.id}`"
        :iconColorClass="item?.iconColorClass"
        :disabled="item?.disabled"
        :iconName="item?.iconName"
        :imageSrc="item?.imageSrc"
        :text="item?.text"
        @onClickOption="onClickOption" />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </DropDownMenuBase>
</template>

<script setup lang="ts">
import DropDownMenuBase from 'frontcore/views/drop-down/views/base/DropDownMenuBase.vue'
import DropDownMenuItem from 'frontcore/views/drop-down/views/unit/DropDownMenuItem.vue'
import {
  DropDownDirection,
  DropDownMenuItemProps,
} from "frontcore/views/drop-down/domain/types"
import { Nullable } from 'frontcore/presentation/types'

interface Props {
  value?: Nullable<number | string>
  optionList: DropDownMenuItemProps[]
  direction?: DropDownDirection
  isSimpleList?: boolean
  width?: number
  keepOrder?: boolean
}
withDefaults(defineProps<Props>(), {
  value: null,
  direction: DropDownDirection.LEFT,
  isSimpleList: false,
  keepOrder: false,
})

type Emits = (e: 'input:value', id: DropDownMenuItemProps['id']) => void
const emit = defineEmits<Emits>()

const onClickOption = (id: DropDownMenuItemProps['id']) => {
  emit('input:value', id)
}
</script>
